exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-ic_close {\n  font-size: 10px; }\n\n::ng-deep div#helpModalTemplate > div > ngb-accordion > div.card > div#overview-header.card-header.active {\n  border-bottom: 0px solid #ececec;\n  background-color: #f7f7f7 !important; }\n\n::ng-deep div#helpModalTemplate {\n  background-color: #f7f7f7 !important; }\n\n::ng-deep div#helpModalTemplate > div > ngb-accordion > div.card {\n  background-color: #f7f7f7 !important;\n  padding: 1rem;\n  font-size: small;\n  text-align: center; }\n\n::ng-deep div#helpModalTemplate > div.modal-header {\n  background-color: white; }\n\n::ng-deep .help-modal > .modal-dialog > .modal-content {\n  padding: 0px; }\n\n.icon-ic_help {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Fed/src/app/components/shared/help/help.component.scss
// module id = ../../../../../src/app/components/shared/help/help.component.scss
// module chunks = main